module.exports = __webpack_public_path__ + "img/mac.5854be4b.png";